import { encryptCryptoKeyWithAes, encryptCryptoKeyWithPublicKey, } from '@lucidlink/ts-crypto/crypto';
import { prepareMemberCommon, } from './prepare-member-common';
export const prepareServiceAdminMember = async (params) => {
    const { member, memberKeys } = await prepareMemberCommon(params);
    const eAdminPrivateKeyByMemberKeyPromise = encryptCryptoKeyWithPublicKey(params.adminKeys.encryptPair.privateKey, memberKeys.encryptPair.publicKey);
    const ePrivateKeyByAccountKeyPromise = encryptCryptoKeyWithAes(memberKeys.encryptPair.privateKey, params.accountKey);
    return {
        ...member,
        eAdminPrivateKeyByMemberKey: await eAdminPrivateKeyByMemberKeyPromise,
        ePrivateKeyByAccountKey: await ePrivateKeyByAccountKeyPromise,
    };
};
export const prepareServiceCollaboratorMember = async (params) => {
    const { member, memberKeys } = await prepareMemberCommon(params);
    const ePrivateKeyByAccountKeyPromise = encryptCryptoKeyWithAes(memberKeys.encryptPair.privateKey, params.accountKey);
    return {
        ...member,
        ePrivateKeyByAccountKey: await ePrivateKeyByAccountKeyPromise,
    };
};
